<template>
    <div class="context-menu display-flex justify-center">
        <VDropdown
            class="ml-sm mt-xxs"
            :placement="props.placement"
            :distance="8"
            :triggers="[props.trigger]"
            :popper-triggers="[props.trigger]"
        >
            <font-awesome-icon
                class="context-menu__icon pointer text-neutral"
                :icon="`fas fa-square-list`"
            />
            <template #popper>
                <div class="context-menu__container p-xxs">
                    <div
                        v-if="props.actionsList && props.actionsList.length > 0"
                        v-for="(item, index) in props.actionsList"
                        class="context-menu__action"
                        @click="onActionClick(`${item?.actionName}`)"
                    >
                        <div
                            v-if="item?.name"
                            class="context-menu__action-inner p-sm display-flex align-items-center"
                        >
                            <font-awesome-icon :icon="`fas ${item?.icon}`" />
                            <p class="text-sm ml-sm">{{ item?.name }}</p>
                        </div>
                    </div>
                    <div v-else class="context-menu__empty">
                        <p>{{ props.noActionsMessage }}</p>
                    </div>
                </div>
            </template>
        </VDropdown>
    </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref } from 'vue'

const emit = defineEmits(['patentsClicked'])

const props = defineProps({
    actionsList: {
        type: Object,
    },
    trigger: {
        type: String,
        default: 'click',
    },
    placement: {
        type: String,
        default: 'top',
    },
    noActionsMessage: {
        type: String,
        default: 'No actions available',
    },
})

const onActionClick = (actionName) => {
    emit(`${actionName}Clicked`)
}
</script>

<style lang="scss">
.context-menu {
    &__action {
        cursor: pointer;
        border-radius: var(--border-radius-sm);
        transition: all 0.3s ease-in-out;

        p,
        svg {
            color: var(--text-primary);
            transition: all 0.3s ease-in-out;
        }

        &:hover {
            background-color: var(--neutral);

            p,
            svg {
                color: var(--text-on-primary);
            }
        }
    }

    &__icon {
        padding: 6px;
        border: solid var(--border-width-thin) var(--color-border-default);
        border-radius: var(--border-radius-sm);
        margin-top: 7px;
    }

    &__empty {
        padding: var(--spacing-xs);
        color: var(--text-secondary);
        font-family: var(--font-family-base) !important;
    }
}

.cta-holder {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover {
        background-color: var(--color-);
    }
}
</style>
